import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Features } from '@app/core/user-permissions/user-permissions.model';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { NotificationType, PaginationMeta } from '@app/shared/interfaces';
import { TasksService } from '@app/shared/services/tasks/tasks.service';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';

@Component({
  standalone: false,
  selector: 'sbnb-ops-overview',
  templateUrl: './ops-overview.component.html',
  styleUrls: ['./ops-overview.component.scss'],
})
export class OpsOverviewComponent implements OnInit {
  dismissedHelp: boolean;
  now = new Date();
  unassignedTasks: any;
  paginationData: PaginationMeta;
  currentOffset: number;
  loading: boolean;
  selectedTask: any;
  deleting: boolean;

  counts$ = this.taskService.getCounts();
  perms$ = this.userPermissionsService;
  Features = Features;

  constructor(
    private taskService: TasksService,
    private userPermissionsService: UserPermissionsService,
    private location: Location,
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastNotificationsService
  ) {}

  ngOnInit() {
    this.loadTasks();
  }

  loadTasks(offset?: number) {
    this.loading = true;
    this.taskService.getUnassigedTasks(offset).subscribe((res) => {
      this.unassignedTasks = res.data;
      this.paginationData = res.meta?.pagination;
      this.loading = false;
    });
  }

  deleteTask(uuid: string) {
    this.deleting = true;

    this.taskService.deleteTask(uuid).subscribe((res) => {
      if (res.errors) {
        this.toast.open(Object.values(res.errors)[0] as string, 'Dismiss', NotificationType.Error);
        this.deleting = false;
      }

      this.deleting = false;
      this.removeTaskFromList(uuid);
    });
  }

  removeTaskFromList(uuid: string) {
    const index = this.unassignedTasks.findIndex((x) => x.uuid === uuid);

    if (index !== -1) {
      this.unassignedTasks.splice(index, 1);
    }
  }

  public handlePageChanged(newPageNo: number) {
    this.currentOffset = newPageNo;

    // We use offsets as the API deals in offsets rather than pages, when requesting data
    const newOffset = newPageNo * this.paginationData.per_page - this.paginationData.per_page;

    // Commit the new offset to the URL - our source of truth for offsets
    const url = this.router.createUrlTree([{ offset: newOffset }], { relativeTo: this.route }).toString();

    this.location.go(url);

    this.loadTasks(this.currentOffset);
  }
}
